import { cn } from '@worldcoo/ui/lib/utils';
import type { ReactNode } from 'react';

export function Animate(props: { children: ReactNode; className?: string }) {
	return (
		<div className={cn('animate-in fade-in-0 duration-300 flex flex-col gap-6', props.className)}>{props.children}</div>
	);
}
